import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Table } from "antd"
import * as FontSize from "../../constants/fontSizes"
import * as Font from "../../constants/fonts"

type Props = {
    cursor: string
    // Not required
    className: string
    // Not required
    openedDetailId: Maybe<string>
    // Id of current opened row in modal. Not required
    rowKey: string
    minWidth: number
    emptyText: string
    tableId: Maybe<string>
    rowClassName?: (record: any, index: string) => any
} & any
type State = {
    boxShadow: string
    showScroll: boolean
}

/**
 * @deprecated - use  '<Table />' from 'uiKit' folder instead
 */

class DataTableLegacy extends React.PureComponent<Props, State> {
    static defaultProps = {
        cursor: "auto",
        tableId: null,
        className: "",
        openedDetailId: "",
        minWidth: 1055,
        emptyText: "No data for selected range",
    }
    dataTableRef = React.createRef()
    minWidth = 1055
    state = {
        boxShadow: "none",
        showScroll: false,
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize)

        if (
            this.dataTableRef &&
            this.dataTableRef.current &&
            // @ts-expect-error
            this.dataTableRef.current.clientWidth <= this.props.minWidth
        ) {
            this.setState({
                boxShadow: "inset -14px 0px 8px -12px rgba(0,0,0,0.2)",
                showScroll: true,
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize)
    }

    handleScroll = (e: any) => {
        if (!this.dataTableRef || !this.dataTableRef.current) {
            return null
        }

        const scrollLeft = e.target.scrollLeft
        // @ts-expect-error
        const maxScrollLeft = this.props.minWidth - this.dataTableRef.current.clientWidth
        const middleShadowValue = "inset -14px 0px 8px -12px rgba(0,0,0,0.2), inset 14px 0px 8px -12px rgba(0,0,0,0.2)"

        if (scrollLeft === 0) {
            return this.setState({
                boxShadow: "inset -14px 0px 8px -12px rgba(0,0,0,0.2), inset 14px 0px 8px -12px rgba(0,0,0,0)",
            })
        } else if (scrollLeft > 0 && scrollLeft < maxScrollLeft && this.state.boxShadow !== middleShadowValue) {
            return this.setState({
                boxShadow: middleShadowValue,
            })
        } else if (scrollLeft >= maxScrollLeft) {
            return this.setState({
                boxShadow: "inset -14px 0px 8px -12px rgba(0,0,0,0), inset 14px 0px 8px -12px rgba(0,0,0,0.2)",
            })
        } else {
            return null
        }
    }
    handleResize = () => {
        if (
            this.dataTableRef.current &&
            // @ts-expect-error
            this.dataTableRef.current.clientWidth <= this.props.minWidth &&
            this.state.showScroll !== true
        ) {
            this.setState({
                boxShadow: "inset -14px 0px 8px -12px rgba(0,0,0,0.2)",
                showScroll: true,
            })
        } else if (
            this.dataTableRef.current &&
            // @ts-expect-error
            this.dataTableRef.current.clientWidth > this.props.minWidth &&
            this.state.showScroll === true
        ) {
            this.setState({
                boxShadow: "none",
                showScroll: false,
            })
        }

        return null
    }

    render() {
        return (
            // @ts-expect-error
            <div ref={this.dataTableRef} onScroll={this.handleScroll}>
                <style jsx={true} global={true}>
                    {`
                        .dataTable thead th {
                            background-color: rgba(0, 0, 0, 0.04);
                        }
                        .dataTable tr:hover {
                            cursor: ${this.props.cursor};
                        }

                        .dataTable .ant-table-thead {
                            font-size: ${FontSize.sm};
                            font-weight: ${Font.Medium};
                        }
                        .dataTable .ant-table-thead th {
                            background-color: rgba(0, 0, 0, 0.04) !important;
                        }

                        .dataTable${this.props.tableId ? ".a" + this.props.tableId : ""} .ant-table-scroll {
                            box-shadow: ${this.state.boxShadow};
                            transition: box-shadow 0.2s ease-in-out;
                        }

                        .hideScroll .ant-table-body {
                            overflow-x: hidden !important;
                        }

                        .showScroll .ant-table-body {
                            overflow-x: scroll !important;
                        }
                    `}
                </style>
                <Table
                    {...this.props}
                    tableLayout="auto"
                    locale={{
                        emptyText: this.props.emptyText,
                    }}
                    className={`dataTable ${this.props.tableId ? "a" + this.props.tableId : ""} ${
                        this.props.className
                    } ${this.state.showScroll ? "showScroll" : "hideScroll"}`}
                    rowKey={this.props.rowKey}
                    scroll={{
                        x: this.props.minWidth,
                    }}
                    rowClassName={(record, index) => {
                        let result = ""

                        // @ts-expect-error
                        if (this.props.openedDetailId === record[this.props.rowKey]) {
                            result = "row-active"
                        } else {
                            result = "row"
                        }

                        return result + " " + (this.props.rowClassName ? this.props.rowClassName(record, index) : "")
                    }}
                />
            </div>
        )
    }
}

export default DataTableLegacy
